import { axiosAjax } from '@app/src/config/axios';
import { hydrateData } from './hydrators';
import { SelectItemModel } from '@app/src/common/Select/SelectModel';
import { isClientEnv } from '@app/src/utils/validations';

export const typeOperationService = {
  async get(categoryId: number): Promise<SelectItemModel[]> {
    const appStorage = isClientEnv() && JSON.parse(localStorage.getItem('app'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${appStorage && appStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.get(process.env.API_OPERATION.replace(':categoryId', '' + categoryId), config);
      if (data.error) {
        throw new Error();
      }
      return hydrateData(data.data);
    } catch (e) {
      throw new Error(e);
    }
  }
};
